export default __webpack_public_path__ + "static/media/portrait.49b649f9.webp";